import React from 'react'
import cx from 'classnames'
import MuiCheckbox from '@mui/material/Checkbox/Checkbox'
import { styled } from '@mui/material/styles'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import MuiTableRow from '@mui/material/TableRow'
import MuiTableCell from '@mui/material/TableCell'
import TealToolTip from 'components/TealToolTip'

export const DISABLED = 0
export const NONE_SELECTED = 1
export const SOME_SELECTED = 2
export const ALL_SELECTED = 3
export const EMPTY_SELECTION = 4

const Checkbox = styled((props) => <MuiCheckbox color='default' {...props} />)({
  color: '#6288a5'
})

const popoverMessage = (state, selectedDealName) => {
  switch (state) {
    case DISABLED: return 'Select at least one deal first to be able to select all deals of the same deal type.'
    case NONE_SELECTED: return `Select all ${selectedDealName} deals on this page`
    case SOME_SELECTED: return `Select all ${selectedDealName} deals on this page`
    case ALL_SELECTED: return 'Deselect all deals on this page'
    case EMPTY_SELECTION: return 'Nothing to select on this page'
    default: return ''
  }
}

const HeaderTableCell = ({ children }) => (
  <MuiTableCell classes={{ root: 'b' }}>{children}</MuiTableCell>
)

export default ({ onSelect, showDealType, state, selectedDealName }) => (
  <MuiTableRow>
    <MuiTableCell padding='checkbox' classes={{ root: 'dn-l dn-d' }}>
      <HeaderCheckbox {...{ state, selectedDealName, onSelect }} />
    </MuiTableCell>
    <HeaderTableCell>Deal</HeaderTableCell>
    <HeaderTableCell>Date</HeaderTableCell>
    {showDealType && <HeaderTableCell><span className='no-wrap w-max-content'>Deal type</span></HeaderTableCell>}
    <MuiTableCell classes={{ root: 'b dn-m' }}>Market</MuiTableCell>
    <MuiTableCell padding='checkbox' classes={{ root: 'dn-t' }}>
      <HeaderCheckbox {...{ state, selectedDealName, onSelect }} />
    </MuiTableCell>
  </MuiTableRow>
)

const HeaderCheckbox = ({ state, selectedDealName, onSelect, placement = 'top-end' }) => (
  <TealToolTip arrow title={popoverMessage(state, selectedDealName)} {...{ placement }}>
    <span>
      <Checkbox
        checkedIcon={
          <CheckBoxIcon
            className={cx({
              'dark-cyan': state === ALL_SELECTED,
              'cadet-blue': state !== ALL_SELECTED
            })}
          />
        }
        checked={state === ALL_SELECTED || state === SOME_SELECTED}
        disabled={state === DISABLED || state === EMPTY_SELECTION}
        onChange={onSelect}
        value='checkedA'
      />
    </span>
  </TealToolTip>
)
